<template>
    <div class="components-container">
        <div class="titles">
            <span class="fonts">教学周数</span>
        </div>

        <el-table :data="teachingWeeks" ref="teachingWeeksTable" :header-cell-style="{ 'text-align': 'center' }" border
            fit tooltip-effect="dark" style="width: 100%">
            <el-table-column label="第一学期" prop="t1.jxJxzs" align="center" v-if="xz*2>=1">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t1.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第二学期" prop="t2.jxJxzs" align="center" v-if="xz*2>=2">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t2.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第三学期" prop="t3.jxJxzs" align="center" v-if="xz*2>=3">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t3.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第四学期" prop="t4.jxJxzs" align="center" v-if="xz*2>=4">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t4.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第五学期" prop="t5.jxJxzs" align="center" v-if="xz*2>=5">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t5.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第六学期" prop="t6.jxJxzs" align="center" v-if="xz*2>=6">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t6.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第七学期" prop="t7.jxJxzs" align="center" v-if="xz*2>=7">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t7.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第八学期" prop="t8.jxJxzs" align="center" v-if="xz*2>=8">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t8.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第九学期" prop="t9.jxJxzs" align="center" v-if="xz*2>=9">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t9.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="第十学期" prop="t10.jxJxzs" align="center" v-if="xz*2>=10">
                <template slot-scope="scope">
                    <el-input-number class="numbers" size="small" v-model="scope.row.t10.jxJxzs" :min="0" :max="100" controls-position="right"
                        @change="handleChange" :disabled="editDisableState"></el-input-number>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>


<script>
    export default {
        props: ["editDisableState", "xz"],
        data() {
            return {
                teachingWeeks: [{
                    t1: {
                        jxJxzs: 18,
                        jxXqxh: 1
                    },
                    t2: {
                        jxJxzs: 18,
                        jxXqxh: 2
                    },
                    t3: {
                        jxJxzs: 18,
                        jxXqxh: 3
                    },
                    t4: {
                        jxJxzs: 18,
                        jxXqxh: 4
                    },
                    t5: {
                        jxJxzs: 18,
                        jxXqxh: 5
                    },
                    t6: {
                        jxJxzs: 18,
                        jxXqxh: 6
                    },
                    t7: {
                        jxJxzs: 18,
                        jxXqxh: 7
                    },
                    t8: {
                        jxJxzs: 18,
                        jxXqxh: 8
                    },
                    t9: {
                        jxJxzs: 18,
                        jxXqxh: 9
                    },
                    t10: {
                        jxJxzs: 18,
                        jxXqxh: 10
                    },
                }, ],
            };
        },
        mounted() {},
        methods: {
            handleChange() {
                let temp = this.teachingWeeks[0];
                let weeks = {
                    first: temp.t1.jxJxzs + "周",
                    second: temp.t2.jxJxzs + "周",
                    third: temp.t3.jxJxzs + "周",
                    fourth: temp.t4.jxJxzs + "周",
                    fifth: temp.t5.jxJxzs + "周",
                    sixth: temp.t6.jxJxzs + "周",
                    seventh: temp.t7.jxJxzs + "周",
                    eighth: temp.t8.jxJxzs + "周",
                    ninth: temp.t9.jxJxzs + "周",
                    tenth: temp.t10.jxJxzs + "周",
                }
                this.$emit('transweeks', weeks);
                this.$emit('changeArrange', temp);
            }
        },
    };
</script>

<style scoped>
    .numbers {
        width: 80%;
    }
</style>



// WEBPACK FOOTER //
// teachingWeeks.vue?20b46ee3